/**
 * Public sample-note experience — canonical route identifiers.
 *
 * Shared because more than one app links to the sample note (the web app's
 * own entry points and the ambient Chrome extension's side panel). Import
 * from here rather than re-deriving path strings: the note id must stay a
 * real UUID — features/jotaudit gates every audit surface on a strict UUID
 * check of the noteId route param, so a non-UUID id renders the note but
 * silently disables JotAudit.
 */
export const SAMPLE_ROUTE_BASE = '/sample-note';

export const SAMPLE_NOTE_ID = '9a1c7b3e-2d64-4f10-9c8a-71e2f4b6d503';

export const SAMPLE_NOTE_PATH = `${SAMPLE_ROUTE_BASE}/${SAMPLE_NOTE_ID}`;

/**
 * sessionStorage key set by the sample-note boot for the lifetime of a sample
 * SPA session. Session-scoped behavior guards (e.g. authenticated host
 * switching) must check this rather than the pathname: product components
 * navigate to real routes before the sample navigation guard remaps them, and
 * effects that fire during that transitional flash would otherwise treat an
 * anonymous sample visitor as a provider session.
 */
export const SAMPLE_SESSION_STORAGE_KEY = 'jotpsych:sample-session';

export const isSampleSession = (): boolean => {
  try {
    return window.sessionStorage.getItem(SAMPLE_SESSION_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};
